import { ConversationStatus } from '@/models/conversation.model';

export type TConversationFilters = {
  conversationId?: string;
  channelId?: number;
  state?: ConversationStatus;
};

export const parseConversationFilters = (params: URLSearchParams): TConversationFilters => ({
  conversationId: params.get('conversationId') || undefined,
  channelId: params.get('channelId') ? Number(params.get('channelId')) : undefined,
  state: (params.get('state') as ConversationStatus) || undefined,
});
